import type { BlockingTaskType } from "@remi/types/tasks";

import { hasCapability, type User } from "../base";

const homeownerBlockingTasks: BlockingTaskType[] = ["HOMEOWNER_SOW_REJECTION"];

export const blockingTask = {
  create: (user: User, blockingTaskType: BlockingTaskType) => {
    if (hasCapability(user, "blockingTask.create")) {
      return true;
    }
    if (hasCapability(user, "blockingTask.create.homeowner")) {
      return homeownerBlockingTasks.includes(blockingTaskType);
    }
    return false;
  },
};
